/**
 * Portal feature flags.
 *
 * `CONFERENCE_ARCHIVE_ENABLED` — the portal's conference Archive/Restore flow
 * POSTs to `/v1/admin/conferences/:id/{archive,restore}`, which the backend
 * does NOT implement on the admin plane: conference archive is currently
 * super_admin/console-only, so those calls 404. Until the backend adds a
 * company_admin (own-company-scoped) conference-archive endpoint — BE-15 / W5
 * in docs/superpowers/specs/2026-07-24-backend-work-list.md — the Archive /
 * Restore controls, the "View archived" link, and the `/conferences/archived`
 * route are all hidden behind this one flag. Flip to `true` once W5 ships
 * (and re-enable the archive-behavior tests gated on it).
 */
export const CONFERENCE_ARCHIVE_ENABLED: boolean = false;
